<template>
    <div class="d-flex justify-space-between align-center" style="font-size:16px;border-bottom:1px solid #CCC;">
        <div :class="the_left_class" :style="highlight_style">{{left_value}}</div>
        <div v-if="show_middle_value" :class="the_mid_class" :style="highlight_style"><b>{{mid_value}}</b></div>
        <div class="d-flex justify-space-between align-center">
            <div :class="the_right_class_1" :style="highlight_style"><b>{{right_value_1}}</b></div>
            <div :class="the_right_class_2" :style="highlight_style"><b>{{right_value_2}}</b></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ScheduleRow",
    props: {
        left_value: {
            type: String,
            default: ""
        },
        right_value_1: {
            type: String,
            default: ""
        },
        right_value_2: {
            type: String,
            default: ""
        },
        show_middle_value: {
            type: Boolean,
            default: false
        },
        is_today: {
            type: Boolean,
            default: false
        },
        mid_value: {
            type: String,
            default: ""
        },
        left_class: {
            type: String,
            default: "text-left pl-5 grey lighten-5 pt-2 pb-2 pr-5 flex-grow-1"
        },
        mid_class: {
            type: String,
            default: "wdth-200 text-left grey lighten-4 pt-2 pb-2 pl-5"
        },
        right_class: {
            type: String,
            default: "wdth-200 pt-2 pb-2 text-left pl-10"
        },
        right_class_1: {
            type: String,
            default: "grey lighten-3 "
        },
        right_class_2: {
            type: String,
            default: "grey lighten-2"
        },
        is_header: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        highlight_style(){
            var str = "";
            if(this.is_today){
              //str = "background-color: #ffffff !important; font-weight: bold; border: 1px dotted red";
              str = "background-color: rgb(255, 255, 255) !important;";
              str = str + "font-weight: bold;";
              str = str + "border: 1px dashed #2b7182 !important;";
              str = str + "color: #2b7182;";
              str = str + "border-right: none !important;";
              str = str + "border-left: none !important;";
            }
            return str;
        },
        the_left_class(){
            var str = "";
            if(this.is_header){
                str = "text-center pl-5 grey lighten-4 pt-2 pb-2  pr-5  font-weight-bold flex-grow-1 ";
            }else{
                str = this.left_class;
            }
            return str;
        },
        the_mid_class(){
            var str = "";
            if(this.is_header){
                str = "wdth-200 text-center pt-2 pb-2  grey lighten-3 font-weight-bold ";
            }else{
                str = this.mid_class;
            }
            return str;
        },
        the_right_class_1(){
            var str = "";
            if(this.is_header){
                //wdth-200 pt-2 pb-2 text-left pl-10
                str = "wdth-200 text-center pt-2 pb-2 pl-5 pr-5 grey  lighten-2 ";
            }else{
                str = this.right_class + ' ' + this.right_class_1;
            }
            return str;
        },
        the_right_class_2(){
            var str = "";
            if(this.is_header){
                str = "wdth-200 text-center pt-2 pb-2 pl-5 pr-5 grey lighten-1 ";
            }else{
                str = this.right_class + ' ' + this.right_class_2;
            }
            return str;
        },
        
    }
}
</script>